import React from "react";
import { compose } from "redux";
import ReactJson from "react-json-view";

const UnderwritingDecisionDataBox = ({
  underwritingDecisionReport = {}
} = {}) => {
  return (
    <div className="mb-5">
      <h1 className="text-2xl font-title mb-2 font-light">
        Underwriting Decision Data
      </h1>
      <div>
        <ReactJson
          src={underwritingDecisionReport}
          name="UnderwritingDecisionData"
          theme="summerfruit:inverted"
          iconStyle="circle"
          collapsed
          displayDataTypes={false}
          displayObjectSize={false}
          enableClipboard={false}
        />
      </div>
    </div>
  );
};

export default compose(UnderwritingDecisionDataBox);
